// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__7ZMxP","selected":"Tabs_selected__aWZZj","toggle":"Tabs_toggle__OLNbX","pill":"Tabs_pill__43Gad"};